@for (t of trackingList; track t; let idx = $index) {
  <div [ngClass]="{ 'card card-body card--ldap-server': trackingList.length > 1 }">
    @if (trackingList.length > 1) {
      <button (click)="onRemoveServer(idx)" class="btn btn-border btn-outline-danger card--ldap-server__delete-button">
        <i [class]="ziroIcons.DELETE_SMALL"></i>
      </button>
    }
    <ziro-admin-ldap-management-settings-ldap-server-url-form
      [entity]="fieldData[idx]"
      (ziroFormsUpdate$)="onFormUpdate($event, idx)"
      [forceValidation$]="forceValidation$"
      [attr.data-automation]="config.dataAutomation + '-' + idx"
      [isParentFormSubmitted]="isFormSubmitted"
    ></ziro-admin-ldap-management-settings-ldap-server-url-form>
  </div>
}

<div class="d-flex justify-content-end">
  <ziro-button
    [cssClass]="'add-ldap-server'"
    [label]="'tkey;admin.ldap.settings.servers.add.label'"
    [icon]="ziroIcons.PLUS"
    [buttonStyle]="buttonStyles.OUTLINE_INFO"
    (clicked)="addServer()"
    [attr.data-automation]="'add-ldap-server-button'"
  ></ziro-button>
</div>
